module.exports = __webpack_public_path__ + "img/plus-yellow.53695a4e.svg";